import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Sentry error monitoring (only when DSN provided)
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    release: process.env.REACT_APP_RELEASE_VERSION || "funnely-frontend@1.0.0",
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,                 // 10% performance tracing
    replaysSessionSampleRate: 0,           // disabled (privacy + cost)
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    beforeSend(event) {
      // Strip sensitive fields
      try {
        const sensitive = ["password", "new_password", "secret_key", "api_key", "token", "authorization"];
        if (event.request?.data) {
          if (typeof event.request.data === "string") {
            try {
              const obj = JSON.parse(event.request.data);
              sensitive.forEach(k => { if (k in obj) obj[k] = "[Filtered]"; });
              event.request.data = JSON.stringify(obj);
            } catch (_) {}
          } else if (typeof event.request.data === "object") {
            sensitive.forEach(k => { if (k in event.request.data) event.request.data[k] = "[Filtered]"; });
          }
        }
      } catch (_) {}
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 40, textAlign: "center" }}>
      <h2 style={{ color: "#195259", fontFamily: "Lexend, sans-serif" }}>Something went wrong</h2>
      <p style={{ color: "#6D6E71" }}>We&apos;ve been notified and will fix this soon.</p>
      <button onClick={() => window.location.reload()} style={{ marginTop: 16, padding: "10px 20px", background: "#FF9A00", color: "#195259", border: "none", borderRadius: 12, fontWeight: 700, cursor: "pointer" }}>Reload</button>
    </div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
